import { IconHeader, Icon } from "../../../../../components";
import { FormCardRadioGroup } from "../../../../../features/auto-form";
import { useTranslate } from "../../../../../features/translation/hooks/use-translation";

import ACCOMMODATION_CLASSIFICATION_OPTIONS from "../data/accommodation-classification-options.json";
const AccommodationCategory = (props) => {
    const { t } = useTranslate();

    return (
        <div className="container">
            <div className="row">
                <div className="col col-12">
                    <IconHeader title={t("form.accommodationPreferences.title")} icon="star" /> 
                </div>
            </div>
            <div className="row">
                <div className="col col-12">
                    <FormCardRadioGroup
                        name="request.accommodation.category"
                        languagesection="form.accommodationPreferences.accommodationCategory"
                        options={ACCOMMODATION_CLASSIFICATION_OPTIONS.map(option => 
                        {
                            return {
                                ...option,
                                label: <div style={{display:"inline-flex",  gap:"var(--space-2)"}}>
                                            {t(`form.accommodationPreferences.accommodationCategory.label.${option.value}`)}
                                            <span style={{display:"inline-flex"}} className = "text lead" >
                                                {option.icons && option.icons.map(i => <Icon icon={i}/>)}
                                            </span>
                                    </div>
                            }
                        }
                        )}
                        required
                    />
                </div>
            </div>
        </div>
    )
}

export default AccommodationCategory;